module.exports = __webpack_public_path__ + "static/media/home3.5d5aceb1.jpg";